import { Component, Prop, h } from '@stencil/core';

import { onQuestionAnswered } from '../../../actions/actions.answers';

@Component({
  tag: 'question-enum',
  styleUrl: 'question-enum.css',
})
export class QuestionEnum {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() isDirty: boolean = false;
  @Prop() heading: string = '';
  @Prop() optionAnswers: { value: boolean | string; label: string; selected: boolean }[];
  @Prop() question = {};
  @Prop() questionId: string = '';
  @Prop() subHeading: string = '';
  @Prop() whenChanged: (selectedAnswer: boolean | string) => void = () => {};
  @Prop() showXLText: boolean = false;
  @Prop() dataTestId: string = '';
  @Prop() isLocked: boolean = false;

  onRadioSelected(clickedAnswerValue: boolean | string) {
    onQuestionAnswered(this.questionId, clickedAnswerValue);

    this.whenChanged(clickedAnswerValue);
  }

  shouldDisplayError() {
    return this.isDirty && this.hasError && this.errorMessage;
  }

  renderOptions = () => {
    return this.optionAnswers.map((answer) => {
      const answerValue = answer.value;
      const answerId = `${this.questionId}-${answerValue}`;

      return (
        <input-rounded-button
          class="xs:w-full sm:w-auto"
          buttonId={answerId}
          data-testId={this.dataTestId ? `${this.dataTestId}Button${answerId}` : null}
          hasError={this.isDirty && this.hasError}
          label={answer.label}
          name={answerId}
          selected={answer.selected}
          whenClicked={() => this.onRadioSelected(answerValue)}
          isLocked={this.isLocked}
        />
      );
    });
  };

  render() {
    const headerClass = {
      'mb-2 text-ico-heading': true,
      'ico-components-heading-large': this.showXLText,
    };

    return (
      <div class="text-ico-body">
        {(this.heading || this.subHeading) && (
          <div class="mb-4">
            {this.heading && <h4 class={headerClass}>{this.heading}</h4>}
            {this.subHeading && <div class="text-sm text-ico-body">{this.subHeading}</div>}
          </div>
        )}
        <div class="flex flex-wrap gap-2 md:gap-4">{this.renderOptions()}</div>
        {this.shouldDisplayError() && <div class="mb-2 text-xs pl-4 text-ico-error">{this.errorMessage}</div>}
      </div>
    );
  }
}
